import { ICache, ICacheController } from '../interface/cache';
import Cache from './cache';

const kCacheKey = '__cache';

function _get(associatedObject: any): ICache | null {
    if (!Object.isExtensible(associatedObject)) {
        return null;
    }

    const keySearch: symbol = Symbol.for(kCacheKey);
    const cacheExisting = (associatedObject as any)[keySearch];
    const cache = cacheExisting || Cache();

    (associatedObject as any)[keySearch] = cache;

    return cache;
}

function CacheController(): ICacheController {
    const globalCacheObj = Cache();

    const controller: ICacheController = {
        getAssociatedCache: _get,
        getGlobalCache: () => globalCacheObj,
    };

    return controller;
}

export default CacheController;
